import {
  InstrumentAction,
  InstrumentEvent,
  InstrumentStatus,
  InstrumentTagType,
  InstrumentUploaderType,
} from '@finverity/graphql';

import { InstrumentApprovalConfigs, InstrumentApprovalMakerSubscriptionEvents } from '../../../types';
import { InstrumentApprovalMakerDataGridColId } from '../../instrument-approval-maker-container/constants';

export enum PayerFinanceRequestMakerFilterIdentifier {
  PendingPayerFinanceRequestMaker = 'PendingPayerFinanceRequestMaker',
  NotFundable = 'NOT_FUNDABLE',
}

export const PAYER_INSTRUMENT_FINANCE_REQUEST_MAKER_CONFIGS: InstrumentApprovalConfigs = {
  companyType: InstrumentUploaderType.Payer,
  pageTitle: 'shell.navigationMenu.submitFinanceRequestMaker',
  actionsDefs: [
    {
      buttonText: 'instrument-approval.actions.reviewAndApprove',
      buttonSvgIconName: 'fvIconInstrumentApprovalReview',
      buttonAppearance: 'primary',
      actionType: InstrumentAction.PayerFinanceMakerApprove,
      disabled: true,
      disabledTooltip: null,
    },
    {
      buttonText: 'instrument-approval.actions.reject',
      buttonSvgIconName: 'fvIconInstrumentApprovalReject',
      buttonAppearance: 'outline',
      destructive: true,
      actionType: InstrumentAction.PayerFinanceMakerReject,
      disabled: true,
      disabledTooltip: null,
    },
  ],
  filtersDefs: [
    {
      identifier: PayerFinanceRequestMakerFilterIdentifier.PendingPayerFinanceRequestMaker,
      label: 'instrument-approval.pages.payerFinanceMaker.filters.pending',
      params: {
        statuses: [InstrumentStatus.PayerFinancePendingMakerConfirmation],
        tags: {
          notIncludes: [
            InstrumentTagType.Deleted,
            InstrumentTagType.NotFundable,
            InstrumentTagType.NoEligibleFundingWindow,
          ],
        },
      },
      count: 0,
      hiddenColumns: [],
    },
    {
      identifier: PayerFinanceRequestMakerFilterIdentifier.NotFundable,
      label: 'instrument-approval.filterLabels.notFundable',
      params: {
        statuses: [InstrumentStatus.PayerFinancePendingMakerConfirmation],
        tags: {
          notIncludes: [InstrumentTagType.Deleted],
          includes: [InstrumentTagType.NotFundable, InstrumentTagType.NoEligibleFundingWindow],
        },
      },
      count: 0,
      hiddenColumns: [
        InstrumentApprovalMakerDataGridColId.DisbursementDate,
        InstrumentApprovalMakerDataGridColId.Tenor,
        InstrumentApprovalMakerDataGridColId.RepaymentDate,
        InstrumentApprovalMakerDataGridColId.AdvanceRate,
        InstrumentApprovalMakerDataGridColId.PrincipalAmount,
        InstrumentApprovalMakerDataGridColId.DisbursementAmount,
        InstrumentApprovalMakerDataGridColId.RepaymentAmount,
        InstrumentApprovalMakerDataGridColId.NetUnfinancedBalance,
        InstrumentApprovalMakerDataGridColId.SellerFeesInAdvance,
        InstrumentApprovalMakerDataGridColId.PayerFeesInAdvance,
        InstrumentApprovalMakerDataGridColId.SellerFeesInArrears,
        InstrumentApprovalMakerDataGridColId.PayerFeesInArrears,
        InstrumentApprovalMakerDataGridColId.TotalSellerFees,
        InstrumentApprovalMakerDataGridColId.TotalPayerFees,
        InstrumentApprovalMakerDataGridColId.TotalFees,
      ],
    },
  ],
  subscriptionEvents: <InstrumentApprovalMakerSubscriptionEvents>{
    approvedSuccess: [InstrumentEvent.PayerFinanceCheckerPending, InstrumentEvent.PayerFinanceMakerApproved],
    approvedFailure: [InstrumentEvent.PayerFinanceMakerPending],
    rejected: [InstrumentEvent.PayerFinanceMakerRejected],
    updated: [InstrumentEvent.InstrumentEdited],
    removed: [InstrumentEvent.InstrumentDeleted],
    added: [InstrumentEvent.PayerFinanceUndidRejection, InstrumentAction.PayerFinanceUndoRejection],
  },
};
